module.exports = __webpack_public_path__ + "tg.svg?bf2a3047a97d8d43b9f790879678a94e";